import './LiksBusyLabel.css';

export type LiksBusyLabelProps = {
  children: React.ReactNode;
  className?: string;
};

/** Inline spinner + label for buttons during long-running actions. */
export function LiksBusyLabel({ children, className }: LiksBusyLabelProps) {
  return (
    <span className={['liks-busy-label', className].filter(Boolean).join(' ')}>
      <span className="liks-busy-label__spinner" aria-hidden />
      <span className="liks-busy-label__text">{children}</span>
    </span>
  );
}
